import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Stethoscope, Heart, Brain, Sun, ArrowRight, MessageSquare, BarChart3, Sparkles, Gauge, ScrollText, Award, Building2, BookOpen, FileText, Wrench, ShoppingBag, LayoutTemplate } from "lucide-react";

const DOORS = [
  { key: "clinic_ops", title: "Clinic Operations",
     desc: "Clients · Assessments · Clinical Review / Findings · Reports · Protocols / Wellness Plans · Follow-Ups",
     to: "/admin/clinical", Icon: Stethoscope,
     color: "from-purple-100 to-purple-200 border-purple-300", primary: true },
  { key: "clinic_protocols", title: "Protocols & Wellness Plans",
     desc: "Clinic Hub · Treatment & wellness protocols · Client protocol assignments",
     to: "/admin/clinic", Icon: ScrollText,
     color: "from-amber-50 to-amber-100 border-amber-200" },
  { key: "clinic_admin", title: "Clinic Administration",
     desc: "Restricted · Integrations · Diagnostics · Queues · System administration",
     to: "/admin/platform", Icon: Wrench,
     color: "from-neutral-100 to-neutral-200 border-neutral-300" },
  { key: "clinic_offers", title: "Services & Offers",
     desc: "Manage services, existing-client services, programs & products · Square links · publish / order — no code changes",
     to: "/admin/offers", Icon: ScrollText,
     color: "from-emerald-50 to-emerald-100 border-emerald-200" },
  { key: "clinic_programs", title: "Program Engine",
     desc: "Build interactive program templates (weeks/modules) · manually enroll clients · Program Runner",
     to: "/admin/programs", Icon: ScrollText,
     color: "from-sky-50 to-sky-100 border-sky-200" },
  { key: "clinic_shop", title: "Shop",
     desc: "Manage products, images, prices, inventory & featured items · view & fulfill Shop orders — no code changes",
     to: "/admin/shop", Icon: ShoppingBag,
     color: "from-purple-50 to-purple-100 border-purple-200" },
  { key: "clinic_website", title: "Website Manager",
     desc: "Edit homepage content — hero, pathways, cards, images, buttons, sections · Draft → Preview → Publish",
     to: "/admin/website", Icon: LayoutTemplate,
     color: "from-fuchsia-50 to-fuchsia-100 border-fuchsia-200" },
];

export default function AdminHub() {
  return (
    <div className="min-h-screen bg-[#FBF8F2]">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
          <span className="font-display text-lg text-slate-900">KISSED Clinic OS</span>
          <Link to="/admin/clinical" className="text-xs text-purple-900 hover:underline" data-testid="admin-hub-back-link">Clinic Workspace →</Link>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-10" data-testid="admin-hub">
        <div className="text-xs uppercase tracking-widest text-slate-500">KISSED Clinic OS</div>
        <h1 className="mt-1 font-display text-4xl text-slate-900">Choose Your Workspace</h1>
        <p className="mt-2 text-sm text-slate-600 max-w-2xl">
          One clinic sign-in, role-based access across your clinic workspace. Click any card to enter.
        </p>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {DOORS.map((d) => (
            <Link
              key={d.key}
              to={d.to}
              className={`rounded-2xl border bg-gradient-to-br ${d.color} p-6 hover:shadow-md transition group`}
              data-testid={`admin-door-${d.key}`}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-white/70 flex items-center justify-center text-slate-900">
                  <d.Icon className="w-5 h-5" />
                </div>
                <div className="font-display text-xl text-slate-900">{d.title}</div>
              </div>
              <p className="mt-3 text-sm text-slate-700 leading-relaxed">{d.desc}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-sm text-slate-900 font-medium">
                Enter <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition" />
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
